import React, { useState, useEffect, useRef } from 'react';

import EFPicture from '@elem/compCommon/EFPicture';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import Close from '@elem/SVGIcon/125wRigidSolarPanel/Close';
import EfSpec from '@elem/ui/ef-spec';
import { ActionsModal } from '../BroadCompatibility';
import gtm from '@/utils/gtm';

export default function LongLasting() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('theProduct.LongLasting');
    const { locale } = useRouter();
    const actions = new Array(2).fill(1);
    const [activeContent, setActiveContent] = useState(0);
    const [activeTab, setActiveTab] = useState('tab_1');

    const IMGS_MAP: any = {
        us: {
            img_1: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1732090284566/125w_long_1.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1731924197794/125w_long_1_h5.jpg',
            },
            img_2: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1731920487239/125w_long_2.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1732101855498/125w_long_2_h5.jpg',
            },
        },
    };

    const IMGS = IMGS_MAP[locale] || IMGS_MAP.us;

    const handleBtnClick = (index: number) => {
        const gtmValue = localStorage.getItem(`--125w-long-open-modal-${index + 1}`) || '';

        if ((!activeContent || activeContent !== index + 1) && !gtmValue) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'product_details',
                tab: t('title'),
                button_name: t(`tip_${index + 1}`),
            });
        }

        if (!!activeContent && activeContent === index + 1) {
            setActiveContent(0);
            return;
        }
        setActiveContent(index + 1);
        localStorage.setItem(`--125w-long-open-modal-${index + 1}`, `${index + 1}`);
    };

    return (
        <div className={`${styles.TheComp}  sp-125w-common ${styles.moduleDesignComponent}`}>
            <EfSpec />

            <div className="info">
                <p className="subtitle">{t('label')}</p>
                <p className="title">{t('title')}</p>
                <p className="desc">{t('desc')}</p>
            </div>
            <div className="long-lasting-imgs">
                <div className={`long-lasting-imgs-box long-lasting-imgs-box-1 ${activeTab === 'tab_1' ? 'long-lasting-imgs-active' : ''}`}>
                    <EFPicture src={IMGS?.img_1?.pc} srcPad={IMGS?.img_1?.h5} srcMobile={IMGS?.img_1?.h5} />
                    <div className="imgs-box-bottom">
                        {actions?.map((item: any, index: number) => (
                            <ActionsModal
                                key={index}
                                position="top"
                                index={index}
                                content={t(`tip_${index + 1}`)}
                                activeStatus={activeContent}
                                onBtnClick={handleBtnClick}
                            />
                        ))}
                    </div>
                </div>
                <div className={`long-lasting-imgs-box long-lasting-imgs-box-2 ${activeTab === 'tab_2' ? 'long-lasting-imgs-active' : ''}`}>
                    <EFPicture src={IMGS?.img_2?.pc} srcPad={IMGS?.img_2?.h5} srcMobile={IMGS?.img_2?.h5} />
                </div>
            </div>

            <div className="long-lasting-tabs">
                <div className={`long-lasting-tab-item ${activeTab === 'tab_1' ? 'long-lasting-tab-active' : ''}`} onClick={() => setActiveTab('tab_1')}>
                    {t('tab_title_1')}
                </div>
                <div className={`long-lasting-tab-item ${activeTab === 'tab_2' ? 'long-lasting-tab-active' : ''}`} onClick={() => setActiveTab('tab_2')}>
                    {t('tab_title_2')}
                </div>
            </div>
            <div className="long-lasting-tabs-content-box">
                <div className={`long-lasting-content ${activeTab === 'tab_1' ? 'lasting-content-active' : ''}`}>
                    {t.rich('tab_desc_1', {
                        sup: (text: string) => <sup>{text}</sup>,
                    })}
                </div>
                <div className={`long-lasting-content ${activeTab === 'tab_2' ? 'lasting-content-active' : ''}`}>
                    {t.rich('tab_desc_2', {
                        sup: (text: string) => <sup>{text}</sup>,
                    })}
                </div>
            </div>
            <EfSpec />
        </div>
    );
}
